import React, { ReactNode } from 'react';

interface RoundedSectionCardProps {
  children: ReactNode;
}

export const RoundedSectionCard: React.FC<RoundedSectionCardProps> = ({ children }) => {
  return <section className="card w-full rounded-lg bg-base-200 p-4 sm:p-6">{children}</section>;
};
